
<script>

    import { createNamespacedHelpers } from 'vuex';
    import ModalWrapper from "./ModalWrapper";

    const { mapActions, mapGetters } = createNamespacedHelpers('modals');

    /**
     * Single use component for housing any modal in the application
     */
    export default {

        name: 'modalsContainer',

        computed: {
            ...mapGetters([
                'current',
                'canDiscard'
            ]),
        },

        methods: {
            ...mapActions([
                'close',
                'update'
            ]),

            onClose (data) {
                this.close(data);
            },

            onCancel () {
                this.close(null);
            },

            onUpdate (data) {
                this.update(data);
            },

            onDiscard () {
                if ( this.canDiscard !== true ) {
                    this.onCancel();
                }
            }
        },

        components: {
            ModalWrapper

        }
    };

</script>

<template>
    <div class="ot-modals" :class="{visible: current !== null}">
        <div class="ot-modals-shim" @click="onDiscard"></div>
        <modal-wrapper :name="current" @cancel="onCancel" @close="onClose" @update="onUpdate">
        </modal-wrapper>
    </div>
</template>

<style scoped lang="less">

    @import (reference) '../../theme/minimum.less';

    .ot-modals {
        .fixed-element();
        transform: translateZ(200px);
        top: 0;
        left: 0;
        right: auto;
        bottom: auto;
        width: 0;
        height: 0;
        overflow: hidden;
        z-index: 50;
        padding-top: @height-main-header + 2rem;
        padding-bottom: 2rem;
        .ot-modals-shim {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: hidden;
            opacity: .7;
            background-color: #6C7A89;
            z-index: 50;
        }
        &.visible {
            right: 0;
            bottom: 0;
            width: auto;
            height: auto;
            .ot-modals-shim {
                display: block;
            }
        }
    }

</style>
